import { Flexbox, Text } from '@morressier/ts';
import { Button, LinkButton } from 'components/ProfileUIComponents';
import styled from 'styled-components';
import { faXmark, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import { getQuery } from 'utils/query';
import { VIEWS } from '../EmailAffiliation';
import { ModalImage } from '../../../styles';
import { logEvent } from 'utils/eventTracking';

const HeaderFooter = styled.div`
  padding: 1rem;
  background-color: var(--color-mono-99);
  text-align: right;
`;

const Content = styled(Flexbox)`
  height: 100%;
  overflow-y: auto;
  padding: 32px;
  background-color: var(--color-mono-99);
`;

const Container = styled(Flexbox)`
  height: 100%;
`;

const CloseButton = styled(LinkButton)`
  margin-left: auto;
`;

const Description = styled(Text)`
  width: 34rem;
  margin-bottom: 2rem;
  text-align: center;
`;

const RinggoldLink = styled.a`
  text-decoration: none;
  color: #1e4b9f;
  border-radius: 0.25rem;
  font-weight: 500;
`;

interface IIntroViewProps {
  handleNavigaiton: (nextView: VIEWS) => void;
  onDismiss: () => void;
}

const IntroView = (props: IIntroViewProps) => {
  const router = useRouter();
  const queryParams = getQuery(router);
  const { handleNavigaiton, onDismiss } = props;

  const onClickButton = () => {
    logEvent('PROFILE_ADD_AFFILIATION_START_CLICKED');
    handleNavigaiton(VIEWS.EmailView);
  };

  return (
    <Container flexDirection="column">
      <HeaderFooter>
        {queryParams.flow !== 'account-activation' && (
          <CloseButton onClick={onDismiss}>
            close
            <FontAwesomeIcon icon={faXmark} />
          </CloseButton>
        )}
      </HeaderFooter>
      <Content
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <ModalImage src="/home-client/shared/flamingo.png" />
        <Text size="h3_new" fontWeight="bold">
          Add your affiliations
        </Text>
        <Description>
          {queryParams.flow === 'account-activation'
            ? `You're almost there. Add your current affiliation to highlight
             your experience and expertise to other users. It will only take a
              few minutes to add your primary affiliation and complete your profile.`
            : `Your career path has shaped your expertise; illustrate it to potential
          collaborators, conference organizers, and publishers. Add your
          affiliation and verify it with an associated email address.`}
        </Description>
        <Button
          color="primary"
          onClick={onClickButton}
          iconAfter={<FontAwesomeIcon icon={faChevronRight} />}
        >
          Start
        </Button>
      </Content>
      <HeaderFooter>
        Powered by{' '}
        <RinggoldLink
          href="https://www.ringgold.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Ringgold&trade;
        </RinggoldLink>
      </HeaderFooter>
    </Container>
  );
};
export default IntroView;
